import React, { useMemo, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Bubble, Card } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { ChartContext } from '@/pages/intelligence/layouts'; // 订阅消费者
import './index.scss';
const ChartConsumer = ChartContext.Consumer;

export const IconList = [
  {
    value: 'bar',
    icon: 'column-chart',
    context: 'dbi_bar_chart',
    disabled: false,
  },
  {
    value: 'line',
    icon: 'discount-chart',
    context: 'dbi_line_chart',
    disabled: false,
  },
  {
    value: 'pie',
    icon: 'pie-chart-icon',
    context: 'dbi_pie_chart',
    disabled: false,
  },
];

export const IconFourList = [
  {
    value: 'stackedLine',
    icon: 'stack-diagram',
    context: 'dbi_stacked_line_chart',
    disabled: false,
  },
  {
    value: 'bar',
    icon: 'column-chart',
    context: 'dbi_bar_chart',
    disabled: false,
  },
  {
    value: 'line',
    icon: 'discount-chart',
    context: 'dbi_line_chart',
    disabled: false,
  },
  {
    value: 'pie',
    icon: 'pie-chart-icon',
    context: 'dbi_pie_chart',
    disabled: false,
  },
];

export const IconStackedLine = [
  {
    value: 'stackedLine',
    icon: 'stack-diagram',
    context: 'dbi_stacked_line_chart',
    disabled: false,
  },
];

const DisabledText = 'dbi_disabled_chart_tips';

export default function CardSlotV2(props: any) {
  // children:  插入内容
  // title: 标题这里字符串和dom元素都可以
  // activeTab: 当前选择tab
  // iconList: 右边的icon 不传的话只显示下载
  // isAction: 如果需要左边右边箭头可以点击去的 true ，默认flase， 可以不传
  // getChange：右边按钮点击事件
  // getEyes: 显示不显示事件按钮
  // onDownload： 下载事件按钮
  // className： 传的类名
  const {
    children,
    title,
    titleStyle,
    activeTab,
    iconList = IconList,
    isAction,
    getChange,
    style,
    className,
    getDetails,
    rightDom,
    iconListExtra,
    rightText,
    rightTip,
    subTitle,
    disableChartType,
    // 是否移除背景色，并且移除hover阴影样式
    isNoBg = false,
    alwaysShowIconList = false,
  } = props;

  const { formatMessage } = useIntl();

  const chartList = useMemo(() => {
    if (Array.isArray(disableChartType) && disableChartType.length > 0) {
      const newList: any[] = [];
      iconList?.forEach((item: any) => {
        if (!disableChartType.includes(item.value)) {
          newList.push(item);
        }
      });
      return newList;
    }
    return iconList;
  }, [iconList, disableChartType]);

  return (
    <>
      <Card
        style={style}
        className={classnames('card-slot-v2', className, { 'no-bg': isNoBg })}
      >
        {title ? (
          <Card.Body
            title={
              <div className="card-slot-v2-title" style={titleStyle}>
                <span className="card-slot-v2-title-text">{title}</span>
                {subTitle && (
                  <span className="card-slot-v2-title-subtext">{subTitle}</span>
                )}
              </div>
            }
            operation={
              rightDom ? (
                rightDom
              ) : (
                <ChartConsumer>
                  {(themeContextValue) => {
                    const { ifResetLegend, setIfResetLegend } =
                      themeContextValue;
                    return (
                      <div className="card-slot-v2-flex">
                        {/** 图标在最左边，hover才展示 */}
                        {chartList?.length > 1 &&
                          chartList?.map((e: any, i: any) => {
                            return (
                              <Bubble
                                content={
                                  e.disabled
                                    ? formatMessage({ id: DisabledText })
                                    : formatMessage({ id: e?.context })
                                }
                                dark
                                key={i}
                                placement={'top-end'}
                                placementOffset={[10, 15]}
                              >
                                <i
                                  style={{
                                    opacity: alwaysShowIconList ? 1 : undefined,
                                  }}
                                  className={`
                          ${
                            e.value == activeTab
                              ? 'card-slot-v2-action'
                              : 'card-slot-v2-item'
                          }
                            ${e.disabled ? 'card-slot-v2-disabled' : null}`}
                                  onClick={() => {
                                    if (!e.disabled && e.value != activeTab) {
                                      if (getChange instanceof Function) {
                                        getChange(e.value);
                                        setIfResetLegend?.(!ifResetLegend);
                                      }
                                    }
                                  }}
                                >
                                  <SvgIcon
                                    type={e.icon}
                                    className="card-slot-v2-charicon"
                                  />
                                </i>
                              </Bubble>
                            );
                          })}

                        {iconListExtra ? iconListExtra : null}

                        {/* 后面还有右侧内容时才保留间距，避免额外操作按钮单独位于末尾时产生无意义空白。 */}
                        {(rightDom || rightText || rightTip) && (
                          <div style={{ display: 'inline-block', marginRight: 4 }}></div>
                        )}

                        {rightDom ? rightDom : null}

                        {rightText ? (
                          <span className="card-slot-v2-right-text">
                            {rightText}
                          </span>
                        ) : null}

                        {rightTip ? (
                          <TipContext
                            className="card-slot-v2-right-tip"
                            Performance="left"
                            tipText={rightTip}
                          />
                        ) : null}
                      </div>
                    );
                  }}
                </ChartConsumer>
              )
            }
          >
            {children ? children : <div className="line-text"></div>}
          </Card.Body>
        ) : (
          <Card.Body>{children}</Card.Body>
        )}
      </Card>
    </>
  );
}
